module.exports = __webpack_public_path__ + "static/media/57.6d7282fa.png";